import React from 'react';

import { WizardValidationError } from '@/core/types/Wizard';

import classes from './styles.module.scss';

interface Props {
    error: WizardValidationError;
}

export default function ErrorTag({ error }: Props) {
    return <span className={`${classes.error}`}>{error.message}</span>;
}
